/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AddWidgetRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'
import {AddWidgetResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/cash/widget_service.pb'


export const addWidget = (request: AddWidgetRequest, options?: CashRequestOptions) => post<AddWidgetRequest, AddWidgetResponse>("/cash-app/goose-cash/v3/add-widget", request, {...options, rejectOnError: true })